import { filetypemime } from "magic-bytes.js";
import { PUBLIC_ENVIRONMENT } from "@/config";

interface FilterImageFilesResult {
  validFiles: FileList;
  invalidFilesNames: string[];
}

async function filterImageFiles(
  files: FileList
): Promise<FilterImageFilesResult> {
  const validFiles: File[] = [];
  const invalidFilesNames: string[] = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    // Check if the file is an image
    if (await isImage(file)) {
      validFiles.push(file);
    } else {
      invalidFilesNames.push(file.name);
    }
  }

  // Create a new FileList from the valid files
  const dataTransfer = new DataTransfer();
  validFiles.forEach((file) => dataTransfer.items.add(file));

  return {
    validFiles: dataTransfer.files,
    invalidFilesNames,
  };
}

async function isImage(file: File): Promise<boolean> {
  const buffer = await file.arrayBuffer();
  const mime = filetypemime(Array.from(new Uint8Array(buffer)));

  return (
    mime.length > 0 &&
    /^image\/(?!.*svg)/.test(mime[0]) &&
    mime[0] !== "application/xml"
  );
  // We are excluding SVG files which have the image/svg+xml mime type
  // react dropzone sends SVGs as application/xml, so we exclude that too
}

const BASE_URL = `https://storage.googleapis.com/moxie-media-public-${PUBLIC_ENVIRONMENT}/`;

function getPublicFileUrl(imagePath: string) {
  return `${BASE_URL}${imagePath}`;
}

export { filterImageFiles, getPublicFileUrl, isImage };
